import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import client from '../api/client';
import { getProducts } from '../api/tracking';

const LEVEL_STYLE: Record<string, any> = {
  저관여: { color: '#00D4AA', bg: '#0F2A22', label: '🟢 저관여' },
  중간관여: { color: '#F6AD55', bg: '#2A1F0D', label: '🟡 중간관여' },
  고관여: { color: '#F56565', bg: '#2A0D0D', label: '🔴 고관여' },
};

export default function Dashboard() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || sessionStorage.getItem('user') || '{}');
  const [summary, setSummary] = useState<any>(null);
  const [products, setProducts] = useState<any[]>([]);
  const [places, setPlaces] = useState<any[]>([]);

  useEffect(() => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (!token) return;
    client.get('/dashboard/summary').then(r => setSummary(r.data)).catch(() => {});
    getProducts().then(r => setProducts(r.data.products)).catch(() => {});
    client.get('/place-rank/places').then(r => setPlaces(r.data.places || [])).catch(() => {});
  }, []);

  const s: any = {
    card: { background: '#161B27', border: '0.5px solid #2A3045', borderRadius: 8, padding: 20, marginBottom: 16 },
    btn: { background: '#00D4AA', border: 'none', borderRadius: 8, padding: '10px 24px', color: '#0A1F18', fontSize: 13, fontWeight: 700, cursor: 'pointer' },
    btnGhost: { background: 'none', border: '0.5px solid #2A3045', borderRadius: 8, padding: '8px 16px', color: '#8892A4', fontSize: 12, cursor: 'pointer' },
    stepBtn: (done: boolean) => ({
      background: done ? '#0F2A22' : '#1A2035',
      border: `1px solid ${done ? '#00D4AA' : '#2A3045'}`,
      borderRadius: 6, padding: '4px 12px',
      color: done ? '#00D4AA' : '#4A5568',
      fontSize: 11, fontWeight: done ? 700 : 400,
    }),
  };

  const planColor: Record<string, string> = {
    free: '#8892A4', basic: '#00D4AA', standard: '#378ADD', pro: '#F6AD55'
  };

  return (
    <Layout>
      <div style={{ maxWidth: 900 }}>

        {/* 소개 섹션 */}
        <div style={{ ...s.card, background: 'linear-gradient(135deg, #0F2A22 0%, #0D1F35 100%)', border: '0.5px solid #00D4AA33', marginBottom: 24 }}>
          <div style={{ color: '#00D4AA', fontSize: 11, fontWeight: 600, letterSpacing: '0.1em', marginBottom: 8 }}>SELLER RANKY</div>
          <div style={{ color: '#E8ECF4', fontSize: 20, fontWeight: 700, marginBottom: 12, lineHeight: 1.4 }}>
            판매에 어려움을 겪는 셀러들의<br />고민을 해결해드립니다
          </div>
          <div style={{ color: '#8892A4', fontSize: 13, lineHeight: 1.8, marginBottom: 20 }}>
            셀러랭키는 <span style={{ color: '#00D4AA', fontWeight: 600 }}>데이터 분석 도구</span>와
            <span style={{ color: '#378ADD', fontWeight: 600 }}> AI 마케팅 전략 도구</span>를 함께 제공하여,
            판매자가 스스로 자신의 상품을 분석하고 체계적인 마케팅 플랜을 세울 수 있도록 도와드립니다.
          </div>
          <div style={{ marginBottom: 8 }}>
            <div style={{ color: '#B0BAC8', fontSize: 12, marginBottom: 12, fontWeight: 600 }}>지금 바로 시작해보세요 →</div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' as const }}>
              {[
                { step: 'Step 1', label: '관여도 진단', path: '/involvement', color: '#00D4AA' },
                { step: 'Step 2', label: '마케팅 전략', path: '/marketing', color: '#378ADD' },
                { step: 'Step 3', label: '키워드 전략', path: '/keyword-strategy', color: '#F6AD55' },
                { step: 'Step 4', label: '전략 리포트', path: '/report', color: '#F56565' },
              ].map(item => (
                <button key={item.step} onClick={() => navigate(item.path)} style={{
                  background: item.color + '18',
                  border: `1px solid ${item.color}55`,
                  borderRadius: 8, padding: '8px 16px',
                  cursor: 'pointer', textAlign: 'left' as const,
                }}>
                  <div style={{ color: item.color, fontSize: 10, fontWeight: 600 }}>{item.step}</div>
                  <div style={{ color: '#E8ECF4', fontSize: 13, fontWeight: 600 }}>{item.label}</div>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* 통계 카드 */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 16 }}>
          <div style={s.card}>
            <div style={{ color: '#4A5568', fontSize: 10, textTransform: 'uppercase' as const, letterSpacing: '0.06em', marginBottom: 6 }}>쇼핑 추적 상품</div>
            <div style={{ color: '#00D4AA', fontSize: 24, fontWeight: 700 }}>{summary?.product_count ?? '-'}</div>
          </div>
          <div style={s.card}>
            <div style={{ color: '#4A5568', fontSize: 10, textTransform: 'uppercase' as const, letterSpacing: '0.06em', marginBottom: 6 }}>플레이스</div>
            <div style={{ color: '#378ADD', fontSize: 24, fontWeight: 700 }}>{places.length}</div>
          </div>
          <div style={s.card}>
            <div style={{ color: '#4A5568', fontSize: 10, textTransform: 'uppercase' as const, letterSpacing: '0.06em', marginBottom: 6 }}>진단 완료</div>
            <div style={{ color: '#F6AD55', fontSize: 24, fontWeight: 700 }}>{summary?.step_progress?.length ?? '-'}</div>
          </div>
          <div style={s.card}>
            <div style={{ color: '#4A5568', fontSize: 10, textTransform: 'uppercase' as const, letterSpacing: '0.06em', marginBottom: 6 }}>플랜</div>
            <div style={{ color: planColor[user.plan] || '#8892A4', fontSize: 24, fontWeight: 700 }}>{user.plan || 'free'}</div>
          </div>
        </div>

        {/* 네이버 쇼핑 순위 추적 */}
        <div style={s.card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <div style={{ color: '#E8ECF4', fontSize: 14, fontWeight: 600 }}>🛍 네이버 쇼핑 순위 추적</div>
            <button style={s.btnGhost} onClick={() => navigate('/shopping')}>전체 보기 →</button>
          </div>
          {products.length === 0 ? (
            <div style={{ color: '#4A5568', fontSize: 13, textAlign: 'center', padding: '20px 0' }}>
              등록된 상품이 없습니다.
              <div style={{ marginTop: 12 }}>
                <button onClick={() => navigate('/shopping')} style={s.btn}>상품 등록하기</button>
              </div>
            </div>
          ) : (
            products.slice(0, 5).map((p: any) => (
              <div key={p.id} onClick={() => navigate('/shopping')}
                style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '12px 0', borderBottom: '0.5px solid #1E2535', cursor: 'pointer' }}
                onMouseEnter={e => (e.currentTarget.style.background = '#1A2035')}
                onMouseLeave={e => (e.currentTarget.style.background = 'none')}>
                {p.thumbnail
                  ? <img src={p.thumbnail} alt="" style={{ width: 48, height: 48, borderRadius: 6, objectFit: 'cover', flexShrink: 0 }} />
                  : <div style={{ width: 48, height: 48, borderRadius: 6, background: '#2A3045', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><span style={{ fontSize: 20 }}>🛍</span></div>
                }
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ color: '#E8ECF4', fontSize: 13, fontWeight: 600, marginBottom: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' as const }}>{p.name}</div>
                  <div style={{ display: 'flex', gap: 10 }}>
                    <span style={{ color: '#8892A4', fontSize: 11 }}>{p.store_name}</span>
                    <span style={{ color: '#4A5568', fontSize: 11 }}>키워드 {p.keyword_count || 0}개</span>
                    {p.auto_track && <span style={{ color: '#00D4AA', fontSize: 11 }}>🟢 자동추적</span>}
                  </div>
                </div>
                <span style={{ color: '#4A5568', fontSize: 12 }}>→</span>
              </div>
            ))
          )}
        </div>

        {/* 플레이스 순위 추적 */}
        <div style={s.card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <div style={{ color: '#E8ECF4', fontSize: 14, fontWeight: 600 }}>📍 네이버 플레이스 순위 추적</div>
            <button style={s.btnGhost} onClick={() => navigate('/place/rank')}>전체 보기 →</button>
          </div>
          {places.length === 0 ? (
            <div style={{ color: '#4A5568', fontSize: 13, textAlign: 'center', padding: '20px 0' }}>
              등록된 플레이스가 없습니다.
              <div style={{ marginTop: 12 }}>
                <button onClick={() => navigate('/place/rank')} style={s.btn}>플레이스 등록하기</button>
              </div>
            </div>
          ) : (
            places.slice(0, 5).map((p: any) => (
              <div key={p.id} onClick={() => navigate('/place/rank')}
                style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '12px 0', borderBottom: '0.5px solid #1E2535', cursor: 'pointer' }}
                onMouseEnter={e => (e.currentTarget.style.background = '#1A2035')}
                onMouseLeave={e => (e.currentTarget.style.background = 'none')}>
                {p.thumbnail
                  ? <img src={p.thumbnail} alt="" style={{ width: 48, height: 48, borderRadius: 6, objectFit: 'cover', flexShrink: 0 }} />
                  : <div style={{ width: 48, height: 48, borderRadius: 6, background: '#2A3045', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><span style={{ fontSize: 20 }}>📍</span></div>
                }
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ color: '#E8ECF4', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>{p.name || '플레이스'}</div>
                  <div style={{ display: 'flex', gap: 10 }}>
                    <span style={{ color: '#8892A4', fontSize: 11 }}>{p.category || ''}</span>
                    {p.auto_track && <span style={{ color: '#00D4AA', fontSize: 11 }}>🟢 자동추적</span>}
                  </div>
                </div>
                <span style={{ color: '#4A5568', fontSize: 12 }}>→</span>
              </div>
            ))
          )}
        </div>

        {/* Step 1~4 진행 현황 */}
        <div style={s.card}>
          <div style={{ color: '#E8ECF4', fontSize: 14, fontWeight: 600, marginBottom: 16 }}>🎯 전략 도구 진행 현황</div>
          {!summary || summary.step_progress?.length === 0 ? (
            <div style={{ color: '#4A5568', fontSize: 13, textAlign: 'center', padding: '20px 0' }}>
              아직 관여도 진단을 하지 않았습니다.
              <div style={{ marginTop: 12 }}>
                <button onClick={() => navigate('/involvement')} style={{ background: 'linear-gradient(135deg, #F6AD55, #ED8936)', border: 'none', borderRadius: 10, padding: '14px 32px', color: '#1A1A2E', fontSize: 15, fontWeight: 700, cursor: 'pointer' }}>
                  🚀 내 제품 마케팅 분석하기
                </button>
              </div>
            </div>
          ) : (
            summary.step_progress.map((p: any, i: number) => {
              const lv = LEVEL_STYLE[p.level];
              return (
                <div key={i} style={{ padding: '12px 0', borderBottom: '0.5px solid #1E2535' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' as const, gap: 8 }}>
                    <div>
                      <div style={{ color: '#E8ECF4', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>{p.title}</div>
                      <span style={{ background: lv?.color + '22', border: `1px solid ${lv?.color}55`, borderRadius: 4, padding: '2px 8px', color: lv?.color, fontSize: 11 }}>{lv?.label}</span>
                    </div>
                    <div style={{ display: 'flex', gap: 6 }}>
                      {[
                        { label: 'Step 1', done: p.step1, path: '/involvement' },
                        { label: 'Step 2', done: p.step2, path: '/marketing' },
                        { label: 'Step 3', done: p.step3, path: '/keyword-strategy' },
                        { label: 'Step 4', done: p.step4, path: '/report' },
                      ].map(step => (
                        <button key={step.label} style={s.stepBtn(step.done)} onClick={() => navigate(step.path)}>
                          {step.done ? '✓' : '○'} {step.label}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>

      </div>
    </Layout>
  );
}
